import { useQuery } from '@tanstack/react-query';
import lineageApiService from '../api/lineageApiService';

export const useIssuesData = (options = {}) => {
  return useQuery({
    queryKey: ['issues-data'],
    queryFn: async () => {
      try {
        const response = await lineageApiService.getIssues({});
        
        if (response && response.data) {
          return response.data;
        } else if (response && response.success === false) {
          throw new Error(response.error || 'Failed to load issues');
        }
        
        // Default structure if response is unexpected
        return {
          issues: {
            high_priority: [],
            medium_priority: [],
            low_priority: []
          },
          summary: {
            total_issues: 0,
            open_issues: 0,
            critical_issues: 0,
            resolved_issues: 0
          }
        };
      } catch (error) {
        console.error('Error in useIssuesData:', error);
        throw error;
      }
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchInterval: 60000, // Refetch every minute
    refetchOnWindowFocus: true,
    ...options
  });
};

export const useIssuesStats = (options = {}) => {
  return useQuery({
    queryKey: ['issues-stats'],
    queryFn: async () => {
      try {
        const response = await lineageApiService.getIssueStats();
        
        if (response && response.stats) {
          return response.stats;
        }
        
        // Default structure
        return {
          total_issues: 0,
          open_issues: 0,
          critical_issues: 0,
          resolved_issues: 0,
          issues_by_severity: {
            critical: 0,
            high: 0,
            medium: 0,
            low: 0
          }
        };
      } catch (error) {
        console.error('Error in useIssuesStats:', error);
        throw error;
      }
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchInterval: 60000, // Refetch every minute
    refetchOnWindowFocus: true,
    ...options
  });
};